import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 通过code获取微信用户信息
  login(arg) {
    return Axios({
      url: requestPrefix.centerUrl + '/users/login',
      method: 'post',
      data: arg
    })
  },
  // 是否是默认密码
  workerisDefaultPwd() {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/isDefaultPwd',
      method: 'get'
    })
  },
  // 获取app下载地址
  getAppDownload() {
    return Axios({
      url: '/project/project/mobileUrl',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/login/index.js